import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'locationAddressTemplate',
  initialState: null as string | null,
  reducers: {
    setLocationAddressTemplate(state, action: PayloadAction<string>) {
      return action.payload || null;
    },
  },
});

export const { setLocationAddressTemplate } = slice.actions;

export default slice.reducer;
